import styled from "@emotion/styled";
import bgPlanTrip from "../../../assets/images/bgPlanTrip.png";

export const InnerWrapper = styled.div(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gridColumn: "1/-1",
  marginBottom: theme?.breakpoints?.isMobile ? 24 : 30,
}));

export const ContentWrapper = styled.div(({theme}) => ({
  gridColumn: theme?.breakpoints?.md ? "1/-1" : "2/16",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  backgroundImage: `url("${bgPlanTrip}")`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  padding: theme?.breakpoints?.isMobile ? "40px 16px" : "64px 48px",
  borderRadius: 26,
  boxShadow: "0px 0px 32px 0px #1D31401F",
  backgroundColor: "#F9F9F9",
}));
export const TitleWrapper = styled.div(({theme, styles}) => ({
  gridColumn: "1/-1",
  marginTop: theme?.breakpoints?.isMobile ? 24 : 30,
  ...styles,
}));

export const MainTextWrapper = styled.div(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  marginBottom: theme?.breakpoints?.isMobile ? 32 : 40,
}));
export const OverlayModal = styled.div(({theme, isOpen}) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "flex-end",
  bottom: 0,
  right: 0,
  margin: "auto",
  zIndex: 10,
}));

export const B20ModalWrapper = styled.div(({theme}) => ({
  width: "100%",
  position: "relative",
  maxHeight: "50vh",
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "4/14",
  backgroundColor: "#E9EEF5",
  borderTopRightRadius: 16,
  overflowY: "auto",
  borderTopLeftRadius: 16,
  display: "grid",
  gridColumnGap: theme?.breakpoints?.isMobile ? 8 : 20,
  gridTemplateColumns: `repeat(${theme?.breakpoints?.isMobile ? 4 : 10}, 1fr)`,
}));

export const TextLarge = styled.div(({theme}) => ({
  fontFamily: theme?.font?.arvo,
  fontSize: theme?.breakpoints?.isMobile ? "1.5rem" : "2.5rem",
  fontWeight: 400,
  lineHeight: theme?.breakpoints?.isMobile ? "2rem" : "3rem",
  textAlign: "left",
  color: theme?.colors?.primaryBlue,
  letterSpacing: theme?.breakpoints?.isMobile ? "initial" : "0.2px",
}));

export const LineWrapper = styled.div(() => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  width: "100%",
}));

export const Emodji = styled.div(({theme}) => ({
  marginInline: theme?.breakpoints?.xs
    ? "18px 5px"
    : theme?.breakpoints?.sm
      ? "20px 5px"
      : "24px 5px",
  fontFamily: "Arvo",
  fontSize: theme?.breakpoints?.xs
    ? "1.5rem"
    : theme?.breakpoints?.sm
      ? "2rem"
      : "2.5rem",
  fontWeight: 400,
  lineHeight: theme?.breakpoints?.xs
    ? "2rem"
    : theme?.breakpoints?.sm
      ? "2.5rem"
      : "3rem",
  textAlign: "left",
  letterSpacing: "0.2em",
  color: "#C0C0C0",
}));

export const MobileSpan = styled.span(({theme}) => ({
  display: "flex",
  marginTop: theme?.breakpoints?.xs ? 17 : 0,
}));
